@if ({
  isLoading: isLoading$ | async,
  }; as content) {
  <div [classList]="classContainer">
    @if (content.isLoading) {
      <local-loader></local-loader>
    } @else {
      <iframe [src]="this.pdfViewer.url || '' | bypassSecurityTrustResourceUrl" frameborder="0"></iframe>
    }
  </div>
}
